import { TPreciseFiltersState, IPreciseFilter } from '../../../types/redux/preciseFilters';

export const getCheckedFiltersCount = (
  preciseFiltersData: IPreciseFilter[],
  preciseFiltersState: TPreciseFiltersState,
): number | undefined => {
  const count = preciseFiltersData.reduce((prevVal, filter) => {
    const filterState = preciseFiltersState[filter.name] || [];

    return prevVal + filterState.length;
  }, 0);

  return count || undefined;
};
